import script from "./upload.vue?vue&type=script&setup=true&lang=js"
export * from "./upload.vue?vue&type=script&setup=true&lang=js"

import "./upload.vue?vue&type=style&index=0&id=80d8e482&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80d8e482"]])

export default __exports__